var SearchSortDataTestId = /* @__PURE__ */ ((SearchSortDataTestId2) => {
  SearchSortDataTestId2["SEARCH_SORT_TRIGGER"] = "search-sort--trigger";
  SearchSortDataTestId2["SEARCH_SORT_MODAL"] = "search-sort--modal";
  SearchSortDataTestId2["SEARCH_SORT_OPTION"] = "search-sort--option";
  return SearchSortDataTestId2;
})(SearchSortDataTestId || {});
export {
  SearchSortDataTestId
};
